import {
  type EnvironmentProviders,
  inject,
  Injector,
  isDevMode,
  makeEnvironmentProviders,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { provideServiceWorker, SwRegistrationOptions } from '@angular/service-worker';
import { filter, take } from 'rxjs';
import { MetadataService } from '../../services/metadata/metadata';

/**
 * Angular service worker, so the reader itself (app shell, fonts, translations, themes) loads
 * without connection. It is only registered for readers whose loan allows offline mode. The
 * downloaded books are not served by it: see `OfflineResourceInliner`.
 */
export function provideOfflineServiceWorker(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideServiceWorker('ngsw-worker.js'),
    {
      provide: SwRegistrationOptions,
      useFactory: (): SwRegistrationOptions => {
        const metadataService = inject(MetadataService);
        const injector = inject(Injector);
        return {
          enabled: !isDevMode(),
          registrationStrategy: () =>
            toObservable(metadataService.isOfflineModeEnabled, { injector }).pipe(
              filter(Boolean),
              take(1),
            ),
        };
      },
    },
  ]);
}
